<template>
  <section>
    <div class="header flex-sb">
      <h3>Internal Documents</h3>
      <div class="btn">
        <v-button
          plain
          @click="showUploadDialog">Upload</v-button>
      </div>
    </div>
    <div class="body">
      <div
        v-show="list.length"
        class="ul">
        <div
          v-for="(val,i) in list"
          :key="i"
          class="list flex-sb">
          <div class="list-l">
            <p class="type">{{typeList[val.type_id]}}</p>
            <p class="remarks">{{val.remark}}</p>
          </div>
          <div class="list-r" >
            <file-container
              :fileData="val.file_data"
              :edit="true"
              is-show-detail
              :is-viewer="true"
              is-none-name
              :title-name="typeList[val.type_id]"
              @dock="handleDock"
              @delete="handleDelete(val.id,typeList[val.type_id])"
            />
            <!--            <v-upload-->
            <!--              v-else-->
            <!--              :fileData="val.file_data"-->
            <!--              card-->
            <!--              @delete="handleDelete(val.id,typeList[val.type_id])"-->
            <!--            ></v-upload>-->
          </div>
        </div>
      </div>
    </div>

    <!-- dialog -->
    <internal-document-dialog
      ref="upload-dialog"
      :is-ticket="isTicket"
      :ticket-id="ticketId"
      :manual_id="manual_id"
      :order_id="order_id"
      @updateDetail="handleUpdateDetail"></internal-document-dialog>
    <show-detail-dialog
      v-model="showDetail"
      :file="file"
      is-ticket
      :type="type"
      :customer="customer"
      :form="form"></show-detail-dialog>
  </section>
</template>

<script>
import InternalDocumentDialog from './dialogs/internal-document-dialog.vue'
import {manualFileDel, ticketInternalFileDel} from '@/api/ticket'
import {manualPolicyFileDel} from '@/api/policy'
import ShowDetailDialog from '@/views/records/policy/components/dialog/show-detail'

export default {
  name: 'InternalDocument',
  components:{
    InternalDocumentDialog,
    ShowDetailDialog
  },
  props:{
    manual_id:{
      type: Number,
      default: 0
    },
    type:{
      type: Number,
      default: 0
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    ticketId:{
      type: [Number,String],
      default: 0
    },
    isTicket:{
      type: Boolean,
      default: false
    },
    order_id:{
      type: Number,
      default: 0
    },
    list:{
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      direct: 0, // 直接入庫
      fileData:{
        thumb_url: 'ddd',
        url: 'ddd',
      },
      typeList:{
        1: 'Quotation',
        2: 'Supporting Document',
        3: 'Other'
      },
      showDetail: false,
      file:{}
    }
  },
  methods: {
    handleDock(data){
      this.file  =data
      this.showDetail = true
    },
    showUploadDialog(){
      this.$refs['upload-dialog'].changeDialog()
    },

    handleDelete(id,name){
      this.$ConfirmBox({
        message: `Are you sure you wana delete ${name}?`
      }).then(() => {
        let params = {}
        if(this.manual_id){
          params = {
            manual_id: this.manual_id,
            id
          }
        }else{
          params = {
            order_id: this.order_id,
            id
          }
        }
        this.uploadFileDel(params)
      })
    },
    uploadFileDel(params){
      if(this.isTicket)
      {
        this.network().ticketInternalFileDel(params)
      }else this.network().manualFileDel(params)
    },
    handleUpdateDetail(){
      this.$emit('updateDetail')
    },

    network(){
      return {
        manualFileDel: async (params) => {
          const {status} = this.manual_id? await manualFileDel(params) : await manualPolicyFileDel(params)
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.handleUpdateDetail()
          }
        },
        ticketInternalFileDel: async (params) => {
          const {status} =  await ticketInternalFileDel({
            ...params,
            ticket_id:this.ticketId
          })
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.handleUpdateDetail()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.body{
  .ul{
    border-radius: 5px;
    border: 1px solid #E1E4E8;
    .list{
      padding: 8px 16px;
      .list-l{
        flex: 1;
        margin-right: 15px;
        .remarks{
          padding-top: 5px;
        }
      }
    }
    .list + .list{
      border-top: 1px solid #E1E4E8;
    }
  }
}
</style>
